import { addDays, startOfDay, subDays } from 'date-fns';

export const getAvailableDateRange = ({
  after,
  before,
}: {
  after: number;
  before: number;
}): {
  after: Date;
  before: Date;
} => ({
  after: startOfDay(subDays(new Date(), after)),
  before: startOfDay(addDays(new Date(), before)),
});
